import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBriefcase = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12 0H4v4H0v5h16V4h-4zm-2 4V2H6v2z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M16 11H9v2H7v-2H0v4h16z"
	})]
});
export default SvgBriefcase;
